/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Customer_Phone_MismatchInputs */

const vi_error_shop_customer_phone_mismatch = /** @type {(inputs: Error_Shop_Customer_Phone_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ gắn được khách có cùng số điện thoại đã xác minh của tài khoản; muốn đổi khách, bỏ liên kết để khách tự xác minh lại.`)
};

/**

* @param {Error_Shop_Customer_Phone_MismatchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_customer_phone_mismatch = /** @type {((inputs?: Error_Shop_Customer_Phone_MismatchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Customer_Phone_MismatchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_customer_phone_mismatch(inputs)
});